// @react/hooks/useWebhook.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { webhookStore } from '@core/stores';

/**
 * React hook for WebhookDelivery operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useWebhook } from '@react/hooks';
 *
 * const WebhookDeliveryList = observer(() => {
 *   const store = useWebhook();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useWebhook() {
  return webhookStore;
}
